import { useEffect, useState } from "react";
import Seo from "../../components/Seo";
import { LoadingState, ErrorState, EmptyState } from "../../components/StateBlocks";
import useAuth from "../../hooks/useAuth";
import api, { ApiError } from "../../utils/api";

function currentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

export default function AdminAudit() {
  const { idToken } = useAuth();
  const [month, setMonth] = useState(currentMonthKey());
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api
      .adminListAudit(idToken, month)
      .then((data) => setEntries(data.entries || []))
      .catch((err) => setError(err instanceof ApiError ? err.message : "Unable to load the audit log."))
      .finally(() => setLoading(false));
  }, [idToken, month]);

  return (
    <>
      <Seo title="Admin Audit Log" />
      <h1>Audit log</h1>
      <div className="form-field">
        <label htmlFor="audit-month">Month</label>
        <input id="audit-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} />
      </div>

      {loading && <LoadingState label="Loading audit log\u2026" />}
      {error && <ErrorState message={error} />}
      {!loading && !error && entries.length === 0 && <EmptyState title="No audit entries for this month" />}
      {!loading && !error && entries.length > 0 && (
        <table className="data-table">
          <caption className="visually-hidden">Admin audit log for {month}</caption>
          <thead>
            <tr>
              <th scope="col">Timestamp</th>
              <th scope="col">Admin</th>
              <th scope="col">Action</th>
              <th scope="col">Target</th>
              <th scope="col">Summary</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={`${entry.timestamp}-${entry.targetId}`}>
                <td>{entry.timestamp}</td>
                <td>{entry.adminSub}</td>
                <td>{entry.action}</td>
                <td>{entry.targetId}</td>
                <td>{entry.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
